var exports = module.exports = {};

exports.API = process.env.NODE_ENV === "production" ? `https://server.john-shenk.com/badlibs` : "http://localhost:8081";
